import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { confirmResetPassword, resetPassword } from "aws-amplify/auth";

export type SendPasswordResetCodeVariables = {
  username: string;
};

export type ConfirmPasswordResetVariables = {
  confirmationCode: string;
  newPassword: string;
  username: string;
};

type SendPasswordResetCodeResult = Awaited<ReturnType<typeof resetPassword>>;
type ConfirmPasswordResetResult = Awaited<
  ReturnType<typeof confirmResetPassword>
>;

export type SendPasswordResetCodeMutationOptions = Omit<
  UseMutationOptions<
    SendPasswordResetCodeResult,
    unknown,
    SendPasswordResetCodeVariables
  >,
  "mutationFn"
>;

export type ConfirmPasswordResetMutationOptions = Omit<
  UseMutationOptions<
    ConfirmPasswordResetResult,
    unknown,
    ConfirmPasswordResetVariables
  >,
  "mutationFn"
>;

export function useSendPasswordResetCodeMutation(
  options?: SendPasswordResetCodeMutationOptions,
) {
  return useMutation({
    mutationFn: ({ username }: SendPasswordResetCodeVariables) =>
      resetPassword({ username }),
    ...options,
  });
}

export function useConfirmPasswordResetMutation(
  options?: ConfirmPasswordResetMutationOptions,
) {
  return useMutation({
    mutationFn: ({
      confirmationCode,
      newPassword,
      username,
    }: ConfirmPasswordResetVariables) =>
      confirmResetPassword({
        username,
        confirmationCode,
        newPassword,
      }),
    ...options,
  });
}
